import { requestIdleCallback } from './requestIdleCallback';

const taskQueue = [];

let handlerId;

/**
 * Using requestIdleCallback for processing pending tasks
 * @param {() => *} fn a function to be executed when there's idle time
 */
export default function schedulePendingTasks(fn) {
  taskQueue.push(fn);

  if (!handlerId) {
    handlerId = requestIdleCallback(processPendingTasks);
  }
}

function processPendingTasks(deadline) {
  while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && taskQueue.length) {
    const fn = taskQueue.shift();
    try {
      fn();
    } catch (error) {
      // console.error('processPendingTasks error:', error);
    }
  }

  if (taskQueue.length) {
    handlerId = requestIdleCallback(processPendingTasks);
  } else {
    handlerId = 0;
  }
}
